import { UseDataReturn } from './useData'

type Props = Pick<
  UseDataReturn,
  'setSearchDrawerOpen' | 'setFilterDrawerOpen' | 'setAddLeadDrawerOpen'
>

export function useHandlers(props: Props) {
  const { setSearchDrawerOpen, setFilterDrawerOpen, setAddLeadDrawerOpen } =
    props

  function handleChangeView(viewName: string) {
    switch (viewName) {
      case 'back':
        setSearchDrawerOpen(false)
        setFilterDrawerOpen(false)
        setAddLeadDrawerOpen(false)
        break
      case 'search':
        setSearchDrawerOpen(true)
        setFilterDrawerOpen(false)
        setAddLeadDrawerOpen(false)
        break
      case 'filter':
        setSearchDrawerOpen(false)
        setFilterDrawerOpen(true)
        setAddLeadDrawerOpen(false)
        break
    }
  }

  return {
    handleChangeView,
  }
}
